// removed by extract-text-webpack-plugin
module.exports = {"loadingbar":"loadingbar__1i_Ce","wrapper":"wrapper__YKePq","text":"text__2eDrT","bar":"bar__2vdW3"};


//////////////////
// WEBPACK FOOTER
// ./components/loadingbar/scss/loadingbar.scss
// module id = awuE
// module chunks = 0